'use client';

import type { ReactNode } from 'react';
import {
  BrowserResultRenderer,
  parseBrowserOutput,
} from './BrowserResultRenderer';
import type { OutputRenderContext } from '../../tool-config-types';

export const renderBrowserResult = (ctx: OutputRenderContext): ReactNode => {
  const { content, maxHeight } = ctx;

  const browserOutput = parseBrowserOutput(content);
  if (!browserOutput) return null;

  return <BrowserResultRenderer data={browserOutput} maxHeight={maxHeight} />;
};
